<ul class="list-group">
  <li class="list-group-item h-100">
    <div class="col-md-4">
      {{ 'profiles.search.summary.title' | translate | titlecase }}
    </div>
    <div class="col-md-4">{{ paramCount }} {{ 'profiles.search.summary.header-1' | translate }}</div>
    <div class="col-md-4 pull-right">
      <!--<button pButton type="button" class="atlas-btn atlas-btn-default pull-right" (click)="toggleSummaryVisible()">
                {{summaryVisible ? ('profiles.search.summary.hide-summary-button'|translate|titlecase) : ('profiles.search.summary.show-summary-button'|translate|titlecase)}}
            </button>-->
    </div>
    <div class="clear-fix"></div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.Keyword">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'common.keyword' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          {{ searchParams.Keyword }}
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.ContactInfoSearchExpressions?.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>
            <strong>{{ 'profiles.search.advanced.contact-info.title' | translate | titlecase }}</strong>
          </strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <ul class="list-unstyled">
            <li class="col-xs-12" *ngFor="let expression of searchParams.ContactInfoSearchExpressions; let i = index">
              <wl-expression-summary [searchExpression]="expression" [hideBinaryOperator]="i > 0"></wl-expression-summary>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  <li
    class="list-group-item"
    *ngIf="
      summaryVisible &&
      (searchParams.BillingAnchorMonth > 0 ||
        searchParams.BillingRevenueItemNum > 0 ||
        searchParams.DuesAmountMin > 0 ||
        searchParams.DuesAmountMax > 0)
    "
  >
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>
            {{ 'profiles.search.advanced.billing.title' | translate | titlecase }}
          </strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-2" *ngIf="searchParams.BillingAnchorMonth > 0">
          {{ billingMonth }}
        </div>
        <div class="col-sm-3" *ngIf="searchParams.BillingRevenueItemNum > 0">
          {{ revenueItemDescription }}
        </div>
        <div class="col-sm-4" *ngIf="searchParams.DuesAmountMin > 0 || searchParams.DuesAmountMax > 0">
          {{ 'common.between' | translate }} {{ searchParams.DuesAmountMin }} {{ 'common.and' | translate }}
          {{ searchParams.DuesAmountMax }}
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.MemberActivitySearchExpressions.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'profiles.search.advanced.member-activity.title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <ul class="list-unstyled">
            <li *ngFor="let expression of searchParams.MemberActivitySearchExpressions; let i = index">
              <div class="col-xs-1">
                <div [hidden]="i === 0">
                  <label *ngIf="expression.BinaryOperator == 0">{{
                    'shared.widgets.expression.binary-operator.and' | translate | titlecase
                  }}</label>
                  <label *ngIf="expression.BinaryOperator == 1">{{
                    'shared.widgets.expression.binary-operator.or' | translate | titlecase
                  }}</label>
                </div>
              </div>
              <div class="col-xs-2">
                {{ memberActivityNames[expression.Field] }}
              </div>
              <div class="col-xs-2">
                <label *ngIf="expression.FieldValueOperator == 0">{{
                  'shared.widgets.expression.value-operator.equals' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 1">{{
                  'shared.widgets.expression.value-operator.contains' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 2">{{
                  'shared.widgets.expression.value-operator.not-equal' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 3">{{
                  'shared.widgets.expression.value-operator.greater-than' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 4">{{
                  'shared.widgets.expression.value-operator.less-than' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 5">{{
                  'shared.widgets.expression.value-operator.in-the-period' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 7">{{
                  'shared.widgets.expression.value-operator.number-of-days-until' | translate | titlecase
                }}</label>
                <label *ngIf="expression.FieldValueOperator == 8">{{
                  'shared.widgets.expression.value-operator.number-of-days-since' | translate | titlecase
                }}</label>
              </div>
              <div class="col-xs-2" *ngIf="expression.FieldValueOperator < 5">
                {{ expression.Value | date: 'dd/MM/yyyy' }}
              </div>
              <div class="col-xs-2" *ngIf="expression.FieldValueOperator == 7 || expression.FieldValueOperator == 8">
                {{ expression.Value }}
              </div>
              <div class="col-xs-2" *ngIf="expression.FieldValueOperator == 5">
                <label *ngIf="expression.Value == datePeriodEnum.Last1Day">{{
                  'shared.widgets.expression.date-period-options.last-1-day' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Last7Days">{{
                  'shared.widgets.expression.date-period-options.last-7-days' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Last30Days">{{
                  'shared.widgets.expression.date-period-options.last-30-days' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.MonthToDate">{{
                  'shared.widgets.expression.date-period-options.month-to-date' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.YearToDate">{{
                  'shared.widgets.expression.date-period-options.year-to-date' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Next7Days">{{
                  'shared.widgets.expression.date-period-options.next-7-days' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Next30Days">{{
                  'shared.widgets.expression.date-period-options.next-30-days' | translate | titlecase
                }}</label>
                <label *ngIf="expression.Value == datePeriodEnum.Next60Days">{{
                  'shared.widgets.expression.date-period-options.next-60-days' | translate | titlecase
                }}</label>
              </div>
              <div class="clear-fix"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && (searchParams.AffCodes?.length || searchParams.ExcludeAffCodes?.length)">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'profiles.search.advanced.affiliation-codes.title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <div *ngIf="searchParams.AffCodes.length">
            {{
              searchParams.MatchAllAffCodes
                ? ('profiles.search.summary.must-have-all-label' | translate)
                : ('profiles.search.summary.must-have-one-label' | translate)
            }}
            <div class="clear-fix"></div>
            <ul class="list-unstyled col-sm-6">
              <li *ngFor="let affCode of searchParams.AffCodes | slice: 0:(allAffCodeVisible ? 9999 : 2)">
                {{ affCode }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col-sm-12">
          <div *ngIf="searchParams.ExcludeAffCodes.length">
            {{
              searchParams.MatchAllExcludeAffCodes
                ? ('profiles.search.summary.must-not-have-all-label' | translate)
                : ('profiles.search.summary.must-have-none-label' | translate)
            }}
            <div class="clear-fix"></div>
            <ul class="list-unstyled col-sm-6">
              <li *ngFor="let affCode of searchParams.ExcludeAffCodes | slice: 0:(allAffCodeVisible ? 9999 : 2)">
                {{ affCode }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="form-group">
        <button pButton type="button" class="atlas-btn atlas-btn-default" *ngIf="hiddenAffCodeCount > 0" [title]="affCodeTooltip" (click)="toggleAffCodeSliceEnd()">
          {{ allAffCodeVisible ? ('common.hide' | translate) : '+' + hiddenAffCodeCount + ' ' + ('common.more' | translate) }}
        </button>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.CategorySearchExpressions.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'profiles.search.advanced.categories.title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <ul class="list-unstyled">
            <li *ngFor="let expression of searchParams.CategorySearchExpressions; let i = index">
              <div class="col-xs-1">
                <div [hidden]="i === 0">
                  <label *ngIf="expression.BinaryOperator == 0">{{
                    'shared.widgets.expression.binary-operator.and' | translate | titlecase
                  }}</label>
                  <label *ngIf="expression.BinaryOperator == 1">{{
                    'shared.widgets.expression.binary-operator.or' | translate | titlecase
                  }}</label>
                </div>
              </div>
              <div class="col-xs-11">
                {{ categoryNames['Id' + expression.Value.toString()] }}
              </div>
              <div class="clear-fix"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.CertificationOptions?.length">
    <div>
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'profiles.search.advanced.certifications.title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <ul class="list-unstyled">
            <li class="col-xs-12" *ngFor="let expression of searchParams.CertificationOptions; let i = index">
              <div class="col-xs-1">
                <div [hidden]="i === 0">
                  <label *ngIf="expression.BinaryOperator == 0">{{
                    'shared.widgets.expression.binary-operator.and' | translate | titlecase
                  }}</label>
                  <label *ngIf="expression.BinaryOperator == 1">{{
                    'shared.widgets.expression.binary-operator.or' | translate | titlecase
                  }}</label>
                </div>
              </div>
              <div class="col-xs-11">
                <label>{{ expression.Value }}</label>
                <div>
                  <ul class="list-unstyled">
                    <li class="col-xs-12" *ngFor="let subExpression of expression.SearchExpressions; let j = index">
                      <wl-expression-summary [searchExpression]="subExpression" [hideBinaryOperator]="j > 0"></wl-expression-summary>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="clear-fix"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.EventsSearchExpressions.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'profiles.search.advanced.events.title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <ul class="list-unstyled">
            <li *ngFor="let expression of searchParams.EventsSearchExpressions; let i = index">
              <div class="col-xs-1">
                <div [hidden]="i === 0">
                  <label *ngIf="expression.BinaryOperator == 0">{{
                    'shared.widgets.expression.binary-operator.and' | translate | titlecase
                  }}</label>
                  <label *ngIf="expression.BinaryOperator == 1">{{
                    'shared.widgets.expression.binary-operator.or' | translate | titlecase
                  }}</label>
                </div>
              </div>
              <div class="col-xs-11">
                <label *ngIf="expression.Field == 'AttendeeForEvent'">{{ 'common.attendee' | translate | titlecase }}</label>
                <label *ngIf="expression.Field == 'SignUpForEven'; t">{{ 'common.sign-up' | translate | titlecase }}</label>
                <label *ngIf="expression.Field == 'NotSignUpOrAttendeeForEvent'">{{
                  'profiles.search.advanced.not-a-signup-or-attendee' | translate | titlecase
                }}</label>
                {{ 'profiles.search.summary.for-event' | translate | titlecase }}
                {{ expression.Value }}
              </div>
              <div class="clear-fix"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && showRelatedProfileSummary">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'profiles.search.advanced.related-profiles.title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <ul class="list-inline stack-mobile col-sm-6">
          <li>
            <label *ngIf="searchParams.RelatedProfileOptions.ResultBehavior == 1">
              {{ 'profiles.search.advanced.related-profiles.filter-results' | translate | titlecase }}
            </label>
          </li>
          <li>
            <label *ngIf="searchParams.RelatedProfileOptions.ResultBehavior == 0">
              {{ 'profiles.search.advanced.related-profiles.add-results' | translate | titlecase }}
            </label>
          </li>
          <li>
            <label *ngIf="searchParams.RelatedProfileOptions.ResultBehavior == 2">
              {{ 'profiles.search.advanced.related-profiles.replace-results' | translate | titlecase }}
            </label>
          </li>
        </ul>
      </div>
      <div class="form-group">
        <ul class="list-unstyled col-sm-8">
          <li *ngIf="searchParams.RelatedProfileOptions.MainContact">
            <label>
              {{ 'profiles.search.advanced.related-profiles.main-contact-label' | translate | titlecase }}
              <span [hidden]="searchParams.RelatedProfileOptions.ResultBehavior == 1">
                {{ 'profiles.search.advanced.related-profiles.of-results' | translate | titlecase }}
              </span>
              <span [hidden]="searchParams.RelatedProfileOptions.ResultBehavior != 1">
                {{ 'profiles.search.advanced.related-profiles.of-member' | translate | titlecase }}
              </span>
            </label>
          </li>
          <li *ngIf="searchParams.RelatedProfileOptions.ReceivesCommunication">
            <label>
              {{ 'profiles.search.advanced.related-profiles.receives-communication-label' | translate | titlecase }}
              <span [hidden]="searchParams.RelatedProfileOptions.ResultBehavior == 1">
                {{ 'profiles.search.advanced.related-profiles.of-results' | translate | titlecase }}
              </span>
              <span [hidden]="searchParams.RelatedProfileOptions.ResultBehavior != 1">
                {{ 'profiles.search.advanced.related-profiles.of-member' | translate | titlecase }}
              </span>
            </label>
          </li>
          <li *ngIf="searchParams.RelatedProfileOptions.PrimaryRelationship">
            <label>
              {{ 'profiles.search.advanced.related-profiles.primary-relation-label' | translate | titlecase }}
            </label>
          </li>
          <li *ngIf="searchParams.RelatedProfileOptions.UseRelatedAs">
            <label>
              {{ 'profiles.search.advanced.related-profiles.related-as-1-label' | translate | titlecase }}
              {{ relationshipName }}

              <span [hidden]="searchParams.RelatedProfileOptions.ResultBehavior == 1">
                {{ 'profiles.search.advanced.related-profiles.of-results' | translate | titlecase }}
              </span>
              <span [hidden]="searchParams.RelatedProfileOptions.ResultBehavior != 1">
                {{ 'profiles.search.advanced.related-profiles.of-member' | translate | titlecase }}
              </span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.CommonDataView.length > 0">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>{{ 'profiles.search.advanced.common-data-views.title' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <label *ngIf="searchParams.CommonDataView == 'All_Members'">{{
            'profiles.search.advanced.common-data-views.view-names.all-members' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Members_And_Main_Contacts'">{{
            'profiles.search.advanced.common-data-views.view-names.all-members-and-main-contacts' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Members_And_Profiles_Who_Receive_Communication'">{{
            'profiles.search.advanced.common-data-views.view-names.all-members-and-profiles-who-receive-communication'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Members_And_Primary_Relations'">{{
            'profiles.search.advanced.common-data-views.view-names.all-members-and-primary-relations' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Individuals_Who_Receive_Communication_From_A_Member'">{{
            'profiles.search.advanced.common-data-views.view-names.all-individuals-who-receive-communication-from-a-member'
              | translate
              | titlecase
          }}</label>
          <label
            *ngIf="searchParams.CommonDataView == 'All_Individuals_Who_Receive_Communication_From_A_Member_Excluding_The_Main_Contact'"
            >{{
              'profiles.search.advanced.common-data-views.view-names.all-individuals-who-receive-communication-from-a-member-excluding-the-main-contact'
                | translate
                | titlecase
            }}</label
          >
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_Invoices'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_Invoices_30_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices-30-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_Invoices_60_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices-60-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_Invoices_90_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices-90-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_Invoices_120_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices-120-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Invoices_Coming_Due_In_The_Next_7_Days'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-invoices-coming-due-in-the-next-7-days'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Invoices_Coming_Due_In_The_Next_14_Days'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-invoices-coming-due-in-the-next-14-days'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Invoices_Coming_Due_In_The_Next_30_Days'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-invoices-coming-due-in-the-next-30-days'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Invoices_Coming_Due_In_The_Next_60_Days'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-invoices-coming-due-in-the-next-60-days'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Organizations'">{{
            'profiles.search.advanced.common-data-views.view-names.all-organizations' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Individuals'">{{
            'profiles.search.advanced.common-data-views.view-names.all-individuals' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Prospects'">{{
            'profiles.search.advanced.common-data-views.view-names.all-prospects' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_My_Prospects'">{{
            'profiles.search.advanced.common-data-views.view-names.all-my-prospects' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_DUES_Invoices'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices' | translate | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_DUES_Invoices_15_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-15-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_DUES_Invoices_30_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-30-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_DUES_Invoices_60_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-60-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_DUES_Invoices_90_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-90-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_Unpaid_DUES_Invoices_120_Days_Past_Due'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-120-days-past-due'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_DUES_Invoices_Coming_Due_In_The_Next_7_Days'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-dues-invoices-coming-due-in-the-next-7-days'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_DUES_Invoices_Coming_Due_In_The_Next_14_Days'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-dues-invoices-coming-due-in-the-next-14-days'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_DUES_Invoices_Coming_Due_In_The_Next_30_Days'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-dues-invoices-coming-due-in-the-next-30-days'
              | translate
              | titlecase
          }}</label>
          <label *ngIf="searchParams.CommonDataView == 'All_Profiles_With_DUES_Invoices_Coming_Due_In_The_Next_60_Days'">{{
            'profiles.search.advanced.common-data-views.view-names.all-profiles-with-dues-invoices-coming-due-in-the-next-60-days'
              | translate
              | titlecase
          }}</label>
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams.VoterVoicehExpressions?.length">
    <div class="container-fluid form-horizontal">
      <div class="col-sm-12">
        <strong>{{ 'profiles.search.advanced.voter-voice.title' | translate }}</strong>
      </div>
      <div class="form-group">
        <ul class="list-unstyled">
          <li *ngFor="let expression of searchParams.VoterVoicehExpressions; let i = index">
            <div class="col-xs-1">
              <div [hidden]="i === 0">
                <label *ngIf="expression.BinaryOperator == 0">{{
                  'shared.widgets.expression.binary-operator.and' | translate | titlecase
                }}</label>
                <label *ngIf="expression.BinaryOperator == 1">{{
                  'shared.widgets.expression.binary-operator.or' | translate | titlecase
                }}</label>
              </div>
            </div>
            <div class="col-xs-2">
              {{ expression.Field }}
            </div>
            <div class="col-xs-2">
              <label *ngIf="expression.FieldValueOperator == 0">{{
                'shared.widgets.expression.value-operator.equals' | translate | titlecase
              }}</label>
              <label *ngIf="expression.FieldValueOperator == 1">{{
                'shared.widgets.expression.value-operator.contains' | translate | titlecase
              }}</label>
              <label *ngIf="expression.FieldValueOperator == 2">{{
                'shared.widgets.expression.value-operator.not-equal' | translate | titlecase
              }}</label>
              <label *ngIf="expression.FieldValueOperator == 3">{{
                'shared.widgets.expression.value-operator.greater-than' | translate | titlecase
              }}</label>
              <label *ngIf="expression.FieldValueOperator == 4">{{
                'shared.widgets.expression.value-operator.less-than' | translate | titlecase
              }}</label>
              <label *ngIf="expression.FieldValueOperator == 5">{{
                'shared.widgets.expression.value-operator.in-the-period' | translate | titlecase
              }}</label>
            </div>
            <div class="col-xs-7">
              <label *ngIf="expression.Field == 'Office'">
                {{ voterVoiceOfficeNames['Id' + expression.Value.toString()] }}
              </label>
              <label *ngIf="expression.Field == 'Official'">
                {{ voterVoiceOfficialNames['Id' + expression.Value.toString()] }}
              </label>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams?.DataViewId > 0">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>
            {{ 'profiles.search.advanced.my-data-views.title' | translate | titlecase }}
          </strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <label>
            {{ dataViewDescr }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <label>
            {{ dataViewSqlText }}
          </label>
        </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams?.NahbMemberTypes?.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>
            {{ 'profiles.search.advanced.nahb-membership-types.title' | translate | titlecase }}
          </strong>
        </div>
      </div>
      <div class="form-group" *ngIf="searchParams.NahbMemberTypes?.length">
        <div class="clear-fix"></div>
        <ul class="list-unstyled col-sm-12">
          <li *ngFor="let memberType of searchParams.NahbMemberTypes | slice: 0:(allMemberTypeVisible ? 9999 : 2)">
            {{ nahbMemberTypeNames['Id' + memberType.toString()] }}
          </li>
        </ul>
      </div>
      <button
        class="atlas-btn atlas-btn-default"
        *ngIf="searchParams.NahbMemberTypes?.length > 2"
        [title]="affCodeTooltip"
        (click)="toggleMemberTypeSliceEnd()"
      >
        {{
          allMemberTypeVisible
            ? ('common.hide' | translate)
            : '+' + (searchParams.NahbMemberTypes?.length - 2).toString() + ' ' + ('common.more' | translate)
        }}
      </button>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams?.NahbBusinessActivities?.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>
            {{ 'profiles.search.advanced.nahb-business-activities.title' | translate | titlecase }}
          </strong>
        </div>
      </div>
      <div class="form-group" *ngIf="searchParams.NahbBusinessActivities?.length">
        <div class="clear-fix"></div>
        <ul class="list-unstyled col-sm-12">
          <li *ngFor="let businessActivity of searchParams.NahbBusinessActivities | slice: 0:(allBusinessActvitiesVisible ? 9999 : 2)">
            {{ nahbBusinessActivityNames['Id' + businessActivity.toString()] }}
          </li>
        </ul>
      </div>
      <button
        class="atlas-btn atlas-btn-default"
        *ngIf="searchParams.NahbBusinessActivities?.length > 2"
        [title]="affCodeTooltip"
        (click)="toggleBusinessActvitiesSliceEnd()"
      >
        {{
          allBusinessActvitiesVisible
            ? ('common.hide' | translate)
            : '+' + (searchParams.NahbBusinessActivities?.length - 2).toString() + ' ' + ('common.more' | translate)
        }}
      </button>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams?.NaaProfileTypes?.length">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>
            {{ 'profiles.search.advanced.naa-profile-types.title' | translate | titlecase }}
          </strong>
        </div>
      </div>
      <div class="form-group" *ngIf="searchParams.NaaProfileTypes?.length">
        <div class="clear-fix"></div>
        <ul class="list-unstyled col-sm-12">
          <li *ngFor="let naaProfileType of searchParams.NaaProfileTypes | slice: 0:(allNaaProfileTypesVisible ? 9999 : 2)">
            {{ naaProfileTypeNames['Id' + naaProfileType.toString()] }}
          </li>
        </ul>
      </div>
      <button
        class="atlas-btn atlas-btn-default"
        *ngIf="searchParams.NaaProfileTypes?.length > 2"
        [title]="affCodeTooltip"
        (click)="toggleNaaProfileTypesSliceEnd()"
      >
        {{
          allNaaProfileTypesVisible
            ? ('common.hide' | translate)
            : '+' + (searchParams.NaaProfileTypes?.length - 2).toString() + ' ' + ('common.more' | translate)
        }}
      </button>
    </div>
  </li>
  <li class="list-group-item" *ngIf="summaryVisible && searchParams?.UseSql">
    <div class="container-fluid form-horizontal">
      <div class="form-group">
        <div class="col-sm-12">
          <strong>
            {{ 'common.advanced' | translate | titlecase }}
          </strong>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <label>
            {{ searchParams.SqlWhereClause }}
          </label>
        </div>
      </div>
    </div>
  </li>
</ul>
